module.exports = __webpack_public_path__ + "img/a.cf5418b2.jpg";